export default {
	state: {
		isRP: {}
	},
	getters: {
		"isRP": state => state.isRP
	},
	mutations: {
		setIsRP(state, payload) {
			state.isRP = payload
		}
	},
	actions: {
		atualizarEstadoIsRP({ commit }, payload) {
			commit('setIsRP', payload)
		}
	}
};